export default __webpack_public_path__ + "static/media/runway.ec92e997.png";